import React, { useEffect } from 'react';
import { Box, Fade, useMediaQuery, useTheme } from '@material-ui/core';
import { useAppContext } from 'contexts/AppContext';
import defaultLocales from 'globals/locales/default';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsKeysGroupForm from 'ui-elements/forms/FsKeysGroupForm';
import { observer } from 'mobx-react';
import { getButtons } from './Keys.style-elements';
import {
  getProductionFieldGroupProps,
  getSandboxFieldGroupProps,
} from './Keys.utils';

const { developersPage: developerLocales } = defaultLocales;

interface KeysProps {
  inStatus: boolean;
  timeout?: number;
}

const Keys: React.FC<KeysProps> = ({ inStatus, timeout = 1000 }) => {
  const {
    keys: {
      data: { production, sandbox },
      init: initKeys,
    },
  } = useAppContext();

  useEffect(() => {
    initKeys();
  }, [initKeys]);
  const theme = useTheme();
  const isUpSm = useMediaQuery(theme.breakpoints.up('sm'), {
    noSsr: true,
  });
  const buttons = getButtons(isUpSm);

  return (
    <>
      <Box marginBottom={4}>
        <Fade in={inStatus} timeout={timeout}>
          <FsPaper
            title={defaultLocales.sandbox}
            subTitle={developerLocales.keys.sandboxUrl}
            buttons={buttons}
          >
            <FsKeysGroupForm
              {...getSandboxFieldGroupProps(sandbox)}
              title={defaultLocales.sandbox}
            />
          </FsPaper>
        </Fade>
      </Box>

      <Fade in={inStatus} timeout={timeout}>
        <FsPaper
          title={defaultLocales.production}
          subTitle={developerLocales.keys.productionUrl}
          buttons={buttons}
        >
          <FsKeysGroupForm
            {...getProductionFieldGroupProps(production)}
            title={defaultLocales.production}
          />
        </FsPaper>
      </Fade>
    </>
  );
};

export default observer(Keys);
